import { useState, useEffect, useCallback } from 'react';

// ค่า "เรียงตาม" ของตารางรายการเบิก ใช้ร่วมกันระหว่าง /finance/expenses (แท็บวันนี้/ค้างดำเนินการ/อนาคต)
// กับ /profile/payment-approval + /profile/expense-review (แท็บวันนี้/ค้าง/อนาคต) — Finance เปลี่ยนจาก
// dropdown แล้ว Profile เรียงตามด้วย จำไว้ใน localStorage ของเบราว์เซอร์นั้นเท่านั้น (ต่อคน ไม่กระทบ user อื่น)
// default ต้องตรงกับ default เดิมของแต่ละแท็บฝั่ง Finance (ดูคอมเมนต์ sortBy ใน ExpensesTabToday.js)
export const EXPENSE_SORT_DEFAULTS = {
  today: { sortBy: 'status', sortDir: 'asc' },
  backlog: { sortBy: 'createdAt', sortDir: 'desc' },
  future: { sortBy: 'createdAt', sortDir: 'desc' },
};

const STORAGE_KEY = 'expenses_sort_pref';

function readAll() {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (e) {
    return {};
  }
}

function readPref(tabKey) {
  const saved = readAll()[tabKey];
  if (saved?.sortBy && (saved.sortDir === 'asc' || saved.sortDir === 'desc')) return saved;
  return EXPENSE_SORT_DEFAULTS[tabKey];
}

// คืน { sortBy, sortDir, setSort } — ฟัง event 'storage' ด้วย ให้หน้าที่เปิดค้างอยู่อีกแท็บ browser
// (เช่น เปิด Profile ไว้แล้วไปเปลี่ยนที่ Finance) เรียงตามทันทีโดยไม่ต้องรีเฟรช
export function useExpenseSortPref(tabKey) {
  const [pref, setPref] = useState(() => readPref(tabKey));

  useEffect(() => {
    setPref(readPref(tabKey));
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY) setPref(readPref(tabKey));
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [tabKey]);

  const setSort = useCallback((sortBy, sortDir) => {
    setPref({ sortBy, sortDir });
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...readAll(), [tabKey]: { sortBy, sortDir } }));
    } catch (e) {
      // localStorage ใช้ไม่ได้ (private mode ฯลฯ) — ยังเรียงได้ในหน้านี้ แค่ไม่จำข้ามหน้า
    }
  }, [tabKey]);

  return { sortBy: pref?.sortBy, sortDir: pref?.sortDir, setSort };
}
